<template>
  <div>
    <v-row class="mx-12">
      <template>
        <v-col
          v-for="(deposit, index) in deposits"
          :key="index"
          cols="4"
        >
          <bankruptcy-card
            :info-item="deposit"
            :icon="'mdi-file-document'"
            :header="deposit.requestName"
            :code-display-name="local.bankruptcy.bankruptcyFile.deposits.codeDisplayName"
            :code="deposit.requestNumber"
            :status=" deposit.status"
            :date="deposit.creationDate"
            :date-display-name="local.bankruptcy.bankruptcyFile.deposits.depositDate"
            :has-actions="true"
            :court-name="deposit.courtName"
            :sub-circle-name="deposit.subCircleName"
            @card-click="viewAttachment(deposit)"
          >
          </bankruptcy-card>
        </v-col>
      </template>
      <v-col cols="12">
        <naj-no-data
          :has-data="deposits && deposits.length > 0"
          :loading="loading"
        ></naj-no-data>
      </v-col>
    </v-row>

    <show-documents-model
      :documents="deposits"
      :selected-index-prop="selectedDocumentIndex"
      :modal-visibility="showDocumentsInfoModal"
      @modalClose="closeDocumentsInfo"
    ></show-documents-model>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('BankruptcyModule');
import BankruptcyCard from '../bankruptcy-card.vue';
import ShowDocumentsModel from '../attachments-tab/show-document-model.vue';

export default {
  name: 'DepositsTab',
  components: {
    BankruptcyCard,
    ShowDocumentsModel,
  },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      selectedDocumentIndex: 0,
      showDocumentsInfoModal: false,
      deposits: [],
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(['getMainRequestDeposits']),
    loadData() {
      this.loading = true;
      this.getMainRequestDeposits(this.requestObjectKey)
        .then((res) => {
          this.deposits = res.data;
        })
        .finally(() => {
          this.loading = false;
        });

    },
    viewAttachment(deposit) {
      this.showDocumentsInfoModal = true;
      this.selectedDocumentIndex = this.deposits.findIndex(a => a.objectKey == deposit.objectKey);
    },

    closeDocumentsInfo() {
      this.showDocumentsInfoModal = false;
      this.selectedDocumentIndex = 0;
    },

  },
};

</script>

<style lang="scss" scoped>
</style>
